import { render, staticRenderFns } from "./RPUserAdd.vue?vue&type=template&id=ff8a4a80&style=height%3A%20100%25%3B"
import script from "./RPUserAdd.vue?vue&type=script&lang=js"
export * from "./RPUserAdd.vue?vue&type=script&lang=js"
import style0 from "./RPUserAdd.vue?vue&type=style&index=0&id=ff8a4a80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports